import {
  USER_NOTIFICATIONS_MODAL_LIST,
  USER_NOTIFICATIONS_MODAL_LIST_SUCCESS,
  USER_NOTIFICATIONS_MODAL_LIST_ERROR,
} from "./actionTypes"

const initialState = {
  notifications: [],
  lastSeen: 0,
  loading: false,
  error: "",
}

const UserNotificationsModal = (state = initialState, action) => {
  switch (action.type) {
    case USER_NOTIFICATIONS_MODAL_LIST:
      state = {
        ...state,
        notifications: [],
        lastSeen: 0,
        loading: true,
        error: "",
      }
      break
    case USER_NOTIFICATIONS_MODAL_LIST_SUCCESS:
      state = {
        ...state,
        loading: false,
        lastSeen: action.payload.data.response.last_seen,
        notifications: action.payload.data.response.notifications,
      }
      break
    case USER_NOTIFICATIONS_MODAL_LIST_ERROR:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default UserNotificationsModal
